import { Stack, Typography } from "@mui/material";
import { localize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

export const ItemAddingNoticeText = () => {
  return (
    <Stack direction="row" justifyContent="center" textAlign="center" sx={{ marginTop: "15px" }}>
      <Typography
        data-testid="adding-item-notice"
        variant="caption1"
        sx={{
          color: "rgba(32, 34, 35, 0.7)",
        }}
      >
        {localize("subscriptions.yourSubscriptions.orderOptionsModal.addItemView.adjustmentSubscriptionNotice")}
      </Typography>
    </Stack>
  );
};
